/*
 *
 * TABBERJS
 *
 * Jquery plugin for tabblable panes,
 * Don't forget to include the scss file for respective styles
 *
 *  Usage:
 *  Tabs = require('./modules/tabs.js');
 *  Tabs.init();
 *
 */

const Tabs = {

	activate(el) {
		el.addClass('active');
		el.attr('aria-selected', 'true');
	},

	show($tab) {
		const controls = $tab.attr('data-controls');
        const target = $(controls);

		if (target.length) {

			Tabs.resetAll($tab); 
			Tabs.activate($tab);
			Tabs.activate(target);

        } else {
            throw new Error('The element does not have a valid target');
        }
    },

	resetAll($tab) {

        const parent = $tab.closest('.js-tabs');
		parent.find('.tabs__item, [data-toggle=tabs]').removeClass('active');
		parent.find('.tabs__item, [data-toggle=tabs]').attr('aria-selected', 'false');
    },

	bindUIEvents() {
		$(document).on('click', '[data-toggle=tabs]', function(e) {

			e.preventDefault();

			Tabs.show($(this));

		});
	},

	init(el) {
		Tabs.bindUIEvents();
	},
};

export default Tabs;
